'use client'

import { useEffect, useState } from 'react'
import { Sidebar } from '@/components/sidebar'

interface ClientSidebarReplacerProps {
  isCollapsedParam?: boolean
  staticSidebarId?: string
}

/**
 * Client-side component that replaces the static sidebar with the dynamic one
 * This ensures seamless hydration while maintaining SSR benefits
 */
export function ClientSidebarReplacer({ isCollapsedParam, staticSidebarId = 'static-sidebar' }: ClientSidebarReplacerProps) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    // Hide static sidebar immediately to prevent flash
    const staticSidebar = document.getElementById(staticSidebarId)
    if (staticSidebar) {
      staticSidebar.style.display = 'none'
    }
    
    // Mark as mounted on client
    setIsMounted(true)
    
    // Remove static sidebar after a brief moment
    const timer = setTimeout(() => {
      if (staticSidebar) {
        staticSidebar.remove()
      }
    }, 100)

    return () => clearTimeout(timer)
  }, [staticSidebarId])

  // Only render dynamic sidebar on client after mount
  // This prevents hydration mismatch
  if (!isMounted) {
    return null
  }

  return <Sidebar isCollapsedParam={isCollapsedParam} />
}
